import { render, staticRenderFns } from "./transferCard.vue?vue&type=template&id=54e18c5b&scoped=true"
import script from "./transferCard.vue?vue&type=script&lang=ts"
export * from "./transferCard.vue?vue&type=script&lang=ts"
import style0 from "./transferCard.vue?vue&type=style&index=0&id=54e18c5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e18c5b",
  null
  
)

export default component.exports